import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25642acd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delivery-service-detail-2-0-wrap" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "items-wrap" }
const _hoisted_4 = { class: "detail-product-list" }
const _hoisted_5 = { class: "product-name" }
const _hoisted_6 = { class: "product-code" }
const _hoisted_7 = { class: "num" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "media-title" }
const _hoisted_10 = {
  key: 2,
  class: "video-content-wrap van-hairline--bottom"
}
const _hoisted_11 = { class: "video-title-wrap" }
const _hoisted_12 = { class: "media-title" }
const _hoisted_13 = { class: "check-result" }
const _hoisted_14 = {
  key: 0,
  class: "check-success-icon"
}
const _hoisted_15 = {
  key: 1,
  class: "check-fail-icon"
}
const _hoisted_16 = { class: "check-text" }
const _hoisted_17 = {
  key: 3,
  class: "normal-cell"
}
const _hoisted_18 = { class: "van-hairline--bottom" }
const _hoisted_19 = {
  key: 0,
  class: "check-result"
}
const _hoisted_20 = {
  key: 0,
  class: "check-text"
}
const _hoisted_21 = {
  key: 0,
  class: "check-success-icon"
}
const _hoisted_22 = {
  key: 1,
  class: "check-fail-icon"
}
const _hoisted_23 = { class: "check-text" }
const _hoisted_24 = { class: "check-result" }
const _hoisted_25 = {
  key: 0,
  class: "check-success-icon"
}
const _hoisted_26 = {
  key: 1,
  class: "check-fail-icon"
}
const _hoisted_27 = { class: "check-text" }
const _hoisted_28 = {
  key: 0,
  class: "operator xag-page__footer"
}

import ShrinkWrap from '@/components/shrink-wrap.vue'
import BlockWrap from './block-wrap.vue'
import {
  ref,
  onMounted,
  computed,
  watch,
  nextTick,
  withDefaults,
} from 'vue'
import { Button, ImagePreview, Toast, Dialog } from 'vant'
import type { InitData } from '@/components/upload/newUploadFIle.vue'
import EvaluatePopup from './evaluate-popup.vue'
import {
  getDeliveryServiceDetail,
  getPreDeliveryServiceDetail,
  getAuthInfo,
  getUnfinishedDeliveryDetail,
  confirmOrder,
  getTicketVideo,
  getXDeliveryServiceDetail,
} from '@/apis/complete-machine-delivery'
import { GetImagesInfo } from '@/apis/public'
import type { TicketItemDetail } from '@/types/complete-machine-delivery'
import { showToastLoading, clearToast } from '@/utils/tools'
import { commonErrorHandle } from '@/utils/error-handle'
import { statusInfoMap } from '@/defination/complete-machine-delivery'
import MediaList from './media-list.vue'
import { ImageInfo } from '@/types/public'

interface MaterialItem {
  name: string
  code: string
  num: number
}

interface VideoItem {
  isVideo: boolean
  url: string
}

interface FormData {
  materialList: MaterialItem[]
  checkOutboundProductInfoImg: string[]
  unpackingInspectionImg: string[]
  productAssemblyImg: string[]
  productAssemblyList: string[]
  policyExplanation: VideoItem[]
  operationalSafety: VideoItem[]
  threePartyInsurance: string
  insurance: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'delivery-service-detail-x',
  props: {
    detail: null
  },
  emits: ['init'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { detail?: TicketItemDetail };




const pageDeliveryDetailInfo = ref(null)
const deliveryDetailInfoRenderList = computed(() => {
  return Object.keys(pageDeliveryDetailInfo.value.steps).reduce((result, key) => {
    const item = pageDeliveryDetailInfo.value.steps[key]
    item.items = (item.items || [])
      .map((_) => {
        return {
          ..._,
          isProduct: _.field === 'product_check',
          isImage:
            _.field === 'open_box_check' ||
            _.field === 'install_photo' ||
            _.field === 'user_signature',
          isVideo: _.field === 'policy_video' || _.field === 'safe_operation_video',
          sub_items: _.sub_items ? _.sub_items.filter((sub) => sub.is_show !== false) : _.sub_items,
        }
      })
      .filter((item) => item.is_show !== false)
      .sort((a, b) => {
        if (a.isImage && !b.isImage) return 1
        if (!a.isImage && b.isImage) return -1
        return 0
      })
    return result.concat(item)
  }, [])
})

// console.log('deliveryDetailInfoRenderList', deliveryDetailInfoRenderList.value)

const deliveryMaterials = computed(() => {
  return (props.detail.material_list || []).map((_) => {
    return {
      name: _.good_name,
      code: _.code,
      num: _.cnt,
    }
  })
})

function getDepolyTypeText(data) {
  return data.value_text
}

expose({
  initDataHandle,
})

// 评价颜色
const titleColor = computed(() => {
  return statusInfoMap.get(props.detail?.info?.status)?.color || '#000000'
})

let evaluatePopupEdit = ref(false)

let formData = ref<FormData>({
  materialList: [],
  checkOutboundProductInfoImg: [],
  unpackingInspectionImg: [],
  productAssemblyImg: [],
  productAssemblyList: ['固件升级', '地面调试', '基础功能测试', '飞行测试'],
  policyExplanation: [],
  operationalSafety: [],
  threePartyInsurance: '',
  insurance: '',
})

let policyExplanationUploadFn: InitData
let operationalSafetyUploadFn: InitData

function getCheckResultText(child: any, parent: any) {
  if (child.field === 'uom_auth') {
    return `${child.passed ? '已' : '未'}认证`
  } else if (parent.field === 'device_benefit') {
    return `${child.passed ? '已' : '未'}领取`
  }
  return child.passed ? '检测通过' : '未检测'
}
watch(
  () => props.detail,
  () => {
    initDataHandle()
  },
  {
    immediate: true,
  }
)

let isShowUnfinishedDelivery = computed(() => {
  return props.detail?.info?.status === 30
})

let isShowFinish = computed(() => {
  return props.detail?.info?.status === 30
})

let isShowEvaluation = computed(() => {
  return (
    [40].includes(props.detail?.info?.status) &&
    !props.detail?.assess_info?.score &&
    props.detail?.info.is_assess_auth
  )
})

let isShowViewEvaluation = computed(() => {
  return [40].includes(props.detail?.info?.status) && !!props.detail?.assess_info?.score
})

let isShowOperator = computed(() => {
  return isShowFinish.value || isShowEvaluation.value || isShowViewEvaluation.value
})

async function initDataHandle() {
  if (props.detail) {
    // 设置物料
    showToastLoading()
    formData.value.materialList = (props.detail.material_list || []).map((_) => {
      return {
        name: _.good_name,
        code: _.code,
        num: _.cnt,
      }
    })
    //
    if ([30, 40].includes(props.detail.info.status)) {
      await Promise.all([
        // getDeliveryServiceDetailHandle(),
        // getPreDeliveryServiceDetailHandle(),
        // getAuthInfoHandle(),
        // getTicketVideoHandle(),
        // initDeliveryDetailInfo(),
      ])
    }
    await initDeliveryDetailInfo()
    clearToast()
  }
}

let evaluatePopupVisible = ref(false)

let evaluatePopupRef = ref<InstanceType<typeof EvaluatePopup>>()

async function confirmHandler(type: string) {
  if (type === 'evaluation') {
    evaluatePopupVisible.value = true
    evaluatePopupEdit.value = true
  } else if (type === 'unfinish') {
    try {
      await Dialog.confirm({
        message: '是否确认未交付',
        confirmButtonColor: '#03BA78',
      })
      showToastLoading()
      let data = await getUnfinishedDeliveryDetail({ order_no: props.detail!.info.order_no })
      console.log('getUnfinishedDeliveryDetail', data)
      emits('init')
    } catch (e) {
      console.log('getUnfinishedDeliveryDetail', e)
    }
    clearToast()
  } else if (type === 'finish') {
    await Dialog.confirm({
      message: '是否确认交付',
      confirmButtonColor: '#03BA78',
    })
    try {
      Toast.loading({
        message: '提交中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      await confirmOrder({ order_no: props.detail.info.order_no as string })
      Toast.success('确认服务完成！')
      emits('init')
    } catch (e) {
      commonErrorHandle(e)
      console.log('getUnfinishedDeliveryDetail', e)
    }
  } else if (type === 'viewEvaluation') {
    evaluatePopupVisible.value = true
    evaluatePopupEdit.value = false
    evaluatePopupRef.value?.initData()
  }
}

// 获取现场交付详情
async function getDeliveryServiceDetailHandle() {
  try {
    await getDeliveryServiceDetail({ wo_guid: props.detail.info.guid })
  } catch (e) {
    console.log('getDeliveryServiceDetailHandle', e)
  }
}

// 获取预交付详情
async function getPreDeliveryServiceDetailHandle() {
  try {
    let data = await getPreDeliveryServiceDetail({ wo_guid: props.detail.info.guid })
    console.log('getPreDeliveryServiceDetailHandle', data)
    formData.value.productAssemblyImg = data.check_outbound_product || []
    formData.value.unpackingInspectionImg = data.open_box_check || []
  } catch (e) {
    console.log('getPreDeliveryServiceDetailHandle', e)
  }
}

async function getAuthInfoHandle() {
  try {
    let data = await getAuthInfo({ wo_guid: props.detail.info.guid })
    console.log('getAuthInfoHandle')
    formData.value.threePartyInsurance = data.policy_no || '-'
    formData.value.insurance = data.policy_number || '-'
  } catch (e) {
    console.log('getPreDeliveryServiceDetailHandle', e)
  }
}

// 获取工单视频
async function getTicketVideoHandle() {
  try {
    let data = await getTicketVideo({ wo_guid: props.detail.info.guid })
    console.log('getTicketVideoHandle', data)
    formData.value.policyExplanation = [
      {
        isVideo: true,
        url: data.video_url || '',
      },
    ]
    formData.value.operationalSafety = [
      {
        isVideo: true,
        url: data.safety_video_url || '',
      },
    ]
    nextTick(() => {
      // policyExplanationUploadNewRef.value?.setFileList(formData.value.policyExplanation)
      // operationalSafetyUploadNewRef.value?.setFileList(formData.value.operationalSafety)
      policyExplanationUploadFn.setFileList(
        formData.value.policyExplanation.map((item) => ({
          isVideo: item.isVideo,
          url: item.url,
        }))
      )
      operationalSafetyUploadFn.setFileList(
        formData.value.operationalSafety.map((item) => ({
          isVideo: item.isVideo,
          url: item.url,
        }))
      )
    })
  } catch (e) {
    console.log('getTicketVideoHandle', e)
  }
}

// 搜集 steps 中所有子项的 current_value（图片/视频 UID），一次请求回所有资源链接并映射回子项
async function fetchAndMapMediaUrls(steps: Record<string, any>) {
  const allUids: string[] = []
  const directUrlItems: Array<{ item: any; url: string }> = []
  // 记录 current_value 是纯字符串 GUID（非 JSON）的 item，用于后续映射
  const rawUidItems: Array<{ item: any; uid: string }> = []
  Object.keys(steps).forEach((stepKey) => {
    const step = steps[stepKey]
    ;(step.items || []).forEach((item: any) => {
      if (item.current_value && typeof item.current_value === 'string') {
        // 如果 current_value 已经是完整的 HTTP 链接，直接记录，无需通过 UID 查询
        if (item.current_value.startsWith('http')) {
          directUrlItems.push({ item, url: item.current_value })
          return
        }
        try {
          const parsed = JSON.parse(item.current_value)
          if (Array.isArray(parsed)) {
            parsed.forEach((uid: string) => {
              if (uid) allUids.push(uid)
            })
          } else if (typeof parsed === 'string' && parsed) {
            // 处理单个 GUID 字符串的情况（JSON 字符串，如 "abc-def-123"）
            allUids.push(parsed)
          }
        } catch (error) {
          // JSON.parse 失败，说明 current_value 是纯字符串（非 JSON 格式），
          // 如 abc-def-123，直接作为单个 UID 处理
          if (item.current_value) {
            rawUidItems.push({ item, uid: item.current_value })
            allUids.push(item.current_value)
          }
        }
      }
    })
  })

  // 处理已经是完整 URL 的 current_value
  directUrlItems.forEach(({ item, url }) => {
    item.urlList = [{ uid: '', url, thumb_url: url, uri: '', isImage: true }]
  })

  if (allUids.length === 0) return

  const imageInfos = await GetImagesInfo({ res_uids: allUids, width: 0, height: 0 })
  const uidUrlMap = new Map<string, ImageInfo>()
  imageInfos.forEach((info) => {
    uidUrlMap.set(info.uid, info)
  })

  // 映射 rawUidItems（纯字符串 GUID）
  rawUidItems.forEach(({ item, uid }) => {
    const info = uidUrlMap.get(uid)
    if (info) {
      item.urlList = [info]
    }
  })

  Object.keys(steps).forEach((stepKey) => {
    const step = steps[stepKey]
    ;(step.items || []).forEach((item: any) => {
      if (item.current_value && typeof item.current_value === 'string') {
        // 跳过已经是完整 URL 的项（已在前面处理过）
        if (item.current_value.startsWith('http')) return
        // 跳过已在 rawUidItems 中处理过的项
        if (rawUidItems.some((r) => r.item === item)) return
        try {
          const parsed = JSON.parse(item.current_value)
          if (Array.isArray(parsed)) {
            item.urlList = parsed.map((uid: string) => uidUrlMap.get(uid)).filter(Boolean)
          } else if (typeof parsed === 'string' && parsed) {
            // 处理单个 GUID 字符串的情况（JSON 字符串）
            const info = uidUrlMap.get(parsed)
            if (info) {
              item.urlList = [info]
            }
          }
        } catch {
          // ignore
        }
      }
    })
  })
}

// 获取页面详情(后端控制)
async function initDeliveryDetailInfo() {
  try {
    let data = await getXDeliveryServiceDetail({ wo_guid: props.detail!.info.guid })
    try {
      await fetchAndMapMediaUrls(data.steps)
    } catch (e) {
      console.log('e', e)
    }
    pageDeliveryDetailInfo.value = data

    // 搜集所有子项中的 current_value（图片/视频 UID），一次请求回所有资源链接

    console.log('getDeliveryDetailInfo', data)
  } catch (e) {
    console.log('getDeliveryDetailInfo', e)
  }
}

onMounted(() => {
  // initDeliveryDetailInfo()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "status-tag",
        style: _normalizeStyle({ color: _unref(titleColor) })
      }, [
        _createElementVNode("div", null, _toDisplayString(__props.detail.info.status_text), 1)
      ], 4),
      (pageDeliveryDetailInfo.value)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(deliveryDetailInfoRenderList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "render-block"
            }, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(item.name), 1),
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items || [], (child, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: child.field || index
                  }, [
                    (child.isProduct)
                      ? (_openBlock(), _createBlock(ShrinkWrap, {
                          key: 0,
                          title: "产品清单",
                          titleStyle: {
                fontSize: '14px',
                lineHeight: '20px',
              },
                          titleWrapStyle: { paddingRight: '12px' }
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_4, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deliveryMaterials), (product, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: index,
                                  class: "van-hairline--bottom"
                                }, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_5, _toDisplayString(product.name || '-'), 1),
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(product.code), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_7, "x" + _toDisplayString(product.num), 1)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      : (child.isImage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (child.field === 'user_signature')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "signature-wrap",
                                  style: _normalizeStyle({ backgroundImage: `url(${child.urlList?.[0]?.url})` })
                                }, null, 4))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("div", _hoisted_9, _toDisplayString(child.name), 1),
                                  _createVNode(MediaList, {
                                    list: child.urlList
                                  }, null, 8, ["list"])
                                ], 64))
                          ]))
                        : (child.isVideo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, _toDisplayString(child.name), 1),
                                _createElementVNode("div", _hoisted_13, [
                                  (child.passed)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_15)),
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(child.passed ? '已' : '未') + "完成", 1)
                                ])
                              ]),
                              _createVNode(MediaList, {
                                list: child.urlList,
                                isVideo: ""
                              }, null, 8, ["list"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", null, _toDisplayString(child.name), 1),
                                (!child.sub_items || child.sub_items.length === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      (child.field === 'deploy_type')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(getDepolyTypeText(child)), 1))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (child.passed)
                                              ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                                              : (_openBlock(), _createElementBlock("i", _hoisted_22)),
                                            _createElementVNode("div", _hoisted_23, _toDisplayString(getCheckResultText(child, item)), 1)
                                          ], 64))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (child.sub_items && child.sub_items.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(child.sub_items, (subChild) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "sub-child-cell van-hairline--bottom",
                                      key: subChild.field
                                    }, [
                                      _createElementVNode("div", null, _toDisplayString(subChild.name), 1),
                                      _createElementVNode("div", _hoisted_24, [
                                        (subChild.passed)
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                                          : (_openBlock(), _createElementBlock("i", _hoisted_26)),
                                        _createElementVNode("div", _hoisted_27, _toDisplayString(getCheckResultText(subChild, child)), 1)
                                      ])
                                    ]))
                                  }), 128))
                                : _createCommentVNode("", true)
                            ]))
                  ], 64))
                }), 128))
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    (_unref(isShowOperator))
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          (_unref(isShowUnfinishedDelivery))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                class: "un-finish-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmHandler('unfinish')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("未完成交付")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isShowFinish))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 1,
                class: "confirm-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmHandler('finish')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认接收设备")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isShowEvaluation))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 2,
                class: "confirm-button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (confirmHandler('evaluation')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("评价")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isShowViewEvaluation))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 3,
                class: "confirm-button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (confirmHandler('viewEvaluation')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查看评价")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(EvaluatePopup, {
      ref_key: "evaluatePopupRef",
      ref: evaluatePopupRef,
      show: _unref(evaluatePopupVisible),
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_isRef(evaluatePopupVisible) ? (evaluatePopupVisible).value = $event : evaluatePopupVisible = $event)),
      onSuccess: _cache[5] || (_cache[5] = ($event: any) => (emits('init'))),
      order_no: props?.detail?.info.order_no,
      isEdit: _unref(evaluatePopupEdit),
      assess_info: props?.detail?.assess_info
    }, null, 8, ["show", "order_no", "isEdit", "assess_info"])
  ], 64))
}
}

})